import{RECEIVE_PRODUCT_LOCATIONS}from"../constants";/**
 * Creates the dispatched RECEIVE_PRODUCT_LOCATIONS action object.
 * @param {string} productCode The ID of the product.
 * @param {Object} [filters={}] Additional parameters.
 * @param {Array} locations List of product locations.
 * @return {Object} The RECEIVE_PRODUCT_LOCATIONS action.
 */var receiveProductLocations=function receiveProductLocations(productCode,filters,locations){return{type:RECEIVE_PRODUCT_LOCATIONS,productCode:productCode,filters:filters,locations:locations};};export default receiveProductLocations;